import { Component, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from '@services/user.service';

@Component({
  selector: 'md-navbar',
  imports: [RouterLink, RouterLinkActive, MatIconModule, TranslateModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  standalone: true
})
export class NavbarComponent {
  userName = signal('');

  userService = inject(UserService);
  constructor() {
    this.userService.getUserName().subscribe(name => {
      if (name) {
        this.userName.set(name);
      }
    });
  }
}
